export default [
  {
    path:"/iframe",
    component: resolve => require(['@/components/iframeMobile/Index'], resolve),
    children: [
      {
        path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframeMobile/matchSchedule/common/RegularSeason/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframeMobile/matchSchedule/common/playOffs/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframeMobile/matchData/common/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframeMobile/matchData/common/MapData'], resolve)
      },
    ],
  },
  {
    path: '/judge/login',
    component: resolve => require(['@/components/judge/JudgeLogin'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
      title: '裁判登录'
    }
  },
  {
    path: '/judge',
    component: resolve => require(['@/components/judge/Index'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    children: [{
      path: 'live_manager',
      component: resolve => require(['@/components/judge/LiveManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '直播控制'
      }
    }, {
      path: 'game_manager',
      component: resolve => require(['@/components/judge/GameManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '比赛管理'
      }
    }, ],
  },
  {
    path: '/tool/create_player_banner',
    component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },
  {
    path: '/playerRadar',
    component: resolve =>
      require(['@/pages/PlayerRadar'], resolve)
  },
]




// WEBPACK FOOTER //
// ./src/router/routerM.js